import React from "react";
import LogoSVG from "../assets/images/main-logo.svg";

const Logo = () => {
  return <img src={LogoSVG} alt="" />;
};

export default Logo;
